<template>
	<strong v-bind:class="numberClass">
		{{ displayNumber.toLocaleString() }}
		<i v-show="threshold >= 0 && number >= threshold" class="fas fa-long-arrow-alt-up"></i>
		<i v-show="threshold >= 0 && number < threshold" class="fas fa-long-arrow-alt-down"></i>
		<i v-show="goalReached" class="fas fa-star gold"></i>
	</strong>
</template>

<script>
	export default {
		name: "AnimatedNumber",
		props: {
			number: {
				default: 0
			},
			threshold: {
				default: -1
			},
			goalReached: {
				default: false
			}
		},
		data() {
			return {
				displayNumber: 0,
				interval:false
			}
		},
		mounted() {
			this.animateChange();
		},
		watch:{
			number() {
				this.animateChange();
			}
		},
		computed: {
			numberClass() {
				if (this.threshold < 0 && !this.goalReached) return null;
				if (this.threshold >= 0 && this.threshold > this.number && !this.goalReached) return "red";
				return "green";
			}
		},
		methods: {
			animateChange() {
				clearInterval(this.interval);
				if (this.number === this.displayNumber) return;
				this.interval = window.setInterval(function() {
					if (this.displayNumber !== this.number) {
            let change = (this.number - this.displayNumber) / 10;
            change = change >= 0 ? Math.ceil(change) : Math.floor(change);
						this.displayNumber = this.displayNumber + change;
					} else clearInterval(this.interval);
				}.bind(this), 5);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// animated-number.vue?75725c3e